import React, { Component } from "react";

const ACTION_CLICK_TIMEOUT = 500;

class Button extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.disallowClick = this.disallowClick.bind(this);
  }

  disallowClick() {
    const self = this;
    self.justClicked = true;
    setTimeout(function () {
      self.justClicked = false;
    }, ACTION_CLICK_TIMEOUT);
  }

  onClick(evt) {
    if (!this.justClicked) {
      this.disallowClick();
      this.props.onClick && this.props.onClick(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  }

  onDoubleClick(evt) {
    if (!this.justClicked) {
      this.disallowClick();
      const clickHandler = this.props.onDoubleClick || this.props.onClick;
      clickHandler && clickHandler(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  }

  render() {
    const propsToPass = Object.assign({}, this.props);
    propsToPass.onClick = this.onClick;
    propsToPass.type = this.props.type || "button";
    propsToPass.onDoubleClick = this.onDoubleClick;
    propsToPass.ref = this.props.forwardedRef;
    delete propsToPass.forwardedRef;
    return <button {...propsToPass}>{this.props.children}</button>;
  }
}

/** @type {any} */
const ForwardedButton = React.forwardRef((props, ref) => {
  return <Button {...props} forwardedRef={ref} />;
});

export default ForwardedButton;
